'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TimePayload(kind, ranges) {
  this.L4 = null;
  this.E7 = null;
  this.L4 = kind;
  this.E7 = ranges;
}
export { $c_Lpresto_types$TimePayload as $c_Lpresto_types$TimePayload };
$p = $c_Lpresto_types$TimePayload.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TimePayload;
/** @constructor */
function $h_Lpresto_types$TimePayload() {
}
export { $h_Lpresto_types$TimePayload as $h_Lpresto_types$TimePayload };
$h_Lpresto_types$TimePayload.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$TimePayload)) {
    var x = this.L4;
    var x$2 = x$0.L4;
    if ((x === x$2)) {
      var x$3 = this.E7;
      var x$4 = x$0.E7;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "TimePayload";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.L4;
  }
  if ((n === 1)) {
    return this.E7;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.GH = (function() {
  return this.L4;
});
function $isArrayOf_Lpresto_types$TimePayload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kg)));
}
export { $isArrayOf_Lpresto_types$TimePayload as $isArrayOf_Lpresto_types$TimePayload };
var $d_Lpresto_types$TimePayload = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TimePayload, "presto.types$TimePayload", ({
  kg: 1,
  d9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$TimePayload as $d_Lpresto_types$TimePayload };
//# sourceMappingURL=presto.types$-Time-Payload.js.map
